import React from "react"
import type { ClientesFornecedorState, FiltroClientes } from "../models/clientesFornecedorModel"
import { ClientesFornecedorInicial } from "../models/clientesFornecedorModel"
import type { ClientesFornecedorAction } from "./clientesFornecedorActions"

interface ClientesFornecedorContextType {
    dados: ClientesFornecedorState
    dispatch: React.Dispatch<ClientesFornecedorAction>
    erroCarregamento: string | null
    buscar: (filtro: FiltroClientes, pagina: number) => void
}

export const ClientesFornecedorContext = React.createContext<ClientesFornecedorContextType>({
    dados: ClientesFornecedorInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    buscar: () => undefined,
})
